export default __webpack_public_path__ + "static/media/icon.fc73001f.svg";